import { useNavigate } from "react-router-dom";

const PaymentPending = () => {
  const navigate = useNavigate();
  return (
    <div className="relative max-w-md bg-white-A700 p-6 mx-auto shadow-md rounded-md mt-5">
      <svg
        fill="#f59e0b"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#f59e0b"
        className="w-16 h-16 mx-auto my-6 animate-pulse"
      >
        <path
          fillRule="evenodd"
          d="M12 2a10 10 0 100 20 10 10 0 000-20zM11 7a1 1 0 012 0v5a1 1 0 01-.293.707l-3 3a1 1 0 01-1.414-1.414L11 11.586V7z"
          clipRule="evenodd"
        />
      </svg>
      <div className="text-center">
        <h3 className="md:text-2xl text-base text-gray-900 font-semibold">
          Payment Pending
        </h3>
        <p className="text-gray-600 my-2">
          Your payment is currently being processed.
        </p>
        <p className="text-gray-600 my-2">
          You will be notified once the status is updated. This might take a few
          moments.
        </p>
        <div className="flex items-center justify-center gap-2 py-5">
          <button
            shape="round"
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white-A700 font-medium rounded-[26px]"
            onClick={() => navigate("/orders")}
          >
            Go to Orders
          </button>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-yellow-500"></div>
    </div>
  );
};

export default PaymentPending;
